import { useCallback, useMemo } from "react";

import { Form, Input, Select } from "antd";

import { RVFormFloatingLabelWrap, BADGE_STATUS, RVLink, RVFormItem, RVStatusSelectOption } from "@regal-voice/ui";
import { usePrerecordedVoiceMessageData } from "ServerData/PrerecordedVoiceMessage/Hooks/usePrerecordedVoiceMessageData/usePrerecordedVoiceMessageData";
import { DEFAULT_QUERY_LOCATION as defaultLocation } from "ServerData/PrerecordedVoiceMessage/queries";
import { RecordingOption } from "Types/Recordings";

import { VoicemailFormItemKeys } from "../constants";

const RECORDINGS_ROUTE = "/settings/recordings";

export function RinglessVMFormItems(): JSX.Element {
    const form = Form.useFormInstance();
    const { data: recordings } = usePrerecordedVoiceMessageData({
        invokedLocation: defaultLocation,
        type: RecordingOption.VOICEMAIL,
    });
    const voicemailOptions = useMemo(() => {
        return recordings?.map((voicemail) => {
            const { friendlyName: name } = voicemail;

            return {
                label: <RVStatusSelectOption name={name} badgeStatus={BADGE_STATUS.ACTIVE} badgeContent={"active"} />,
                value: voicemail.id,
            };
        });
    }, [recordings]);

    const handleAudioSelect = useCallback(
        (value: string) => {
            const rec = recordings?.find((file) => file.id === value);
            form.setFieldValue(VoicemailFormItemKeys.voicemailDisplayName, rec?.friendlyName);
            form.setFieldValue(VoicemailFormItemKeys.voicemailFilename, rec?.recordingFilename);
        },
        [form, recordings]
    );

    return (
        <>
            <RVFormFloatingLabelWrap
                showFormLabel
                name={VoicemailFormItemKeys.voicemailId}
                label="Recording Name"
                rules={[
                    {
                        required: true,
                        message: "Recording is required.",
                    },
                ]}
                extra={<RVLink to={RECORDINGS_ROUTE} text="Edit Recording" />}
            >
                <Select options={voicemailOptions} onChange={handleAudioSelect} />
            </RVFormFloatingLabelWrap>
            <RVFormItem name={VoicemailFormItemKeys.voicemailDisplayName} hidden>
                <Input />
            </RVFormItem>
            <RVFormItem name={VoicemailFormItemKeys.voicemailFilename} hidden>
                <Input />
            </RVFormItem>
        </>
    );
}
